import { render, staticRenderFns } from "./V2UsernameChangeModal.vue?vue&type=template&id=2057d9b4&scoped=true&"
import script from "./V2UsernameChangeModal.vue?vue&type=script&lang=js&"
export * from "./V2UsernameChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./V2UsernameChangeModal.vue?vue&type=style&index=0&id=2057d9b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2057d9b4",
  null
  
)

export default component.exports